var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImg3Clicked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_883_7054)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_883_7054",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_883_7054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69029 -9.86538C8.69169 -10.6352 9.51458 -11.1566 10.2113 -10.8291C16.0537 -8.0828 24.4267 -5.39565 27.8116 -0.0537353C31.1965 5.28818 30.0506 14.0067 30.0389 20.4623C30.0375 21.2321 29.2146 21.7535 28.5179 21.426C22.6755 18.6797 14.3024 15.9926 10.9176 10.6507C7.5327 5.30877 8.67858 -3.40977 8.69029 -9.86538Z",
    fill: "#E2BBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.336 -5.22591C15.2905 -6.32953 14.355 -7.20005 13.2657 -7.01733C11.8585 -6.7813 10.4862 -6.35757 9.18611 -5.75521C7.27967 -4.87189 5.56588 -3.62173 4.14258 -2.07609C2.71928 -0.530449 1.61435 1.2804 0.890883 3.25305C0.397518 4.59829 0.0881362 6.0008 -0.0313276 7.42266C-0.123807 8.52334 0.820724 9.38403 1.92435 9.33855L13.914 8.84448C15.0176 8.799 15.8754 7.86747 15.83 6.76384L15.336 -5.22591Z",
    fill: "#66B1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4045 13.1472C12.4588 12.8176 13.0606 11.6849 12.5607 10.6999C11.4391 8.48985 9.6516 6.66534 7.42712 5.50041C4.60776 4.02394 1.31735 3.72792 -1.72026 4.67748C-4.75787 5.62705 -7.29385 7.7444 -8.77032 10.5638C-9.93526 12.7882 -10.3653 15.3059 -10.0286 17.7614C-9.87847 18.8557 -8.7386 19.444 -7.68435 19.1144L1.86008 16.1308L11.4045 13.1472Z",
    fill: "#267CBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.70829 28.6582C2.24177 28.9538 2.09998 29.5746 2.43338 30.0149C3.65776 31.6319 5.27576 32.9167 7.14012 33.7425C9.31012 34.7037 11.7164 34.9998 14.0547 34.5934C16.393 34.187 18.5583 33.0964 20.2768 31.4594C21.9952 29.8223 23.1897 27.7125 23.709 25.3967C24.2284 23.0808 24.0494 20.6629 23.1947 18.4488C22.3399 16.2347 20.8478 14.3238 18.907 12.9577C16.9662 11.5916 14.6639 10.8318 12.2913 10.7742C10.2528 10.7247 8.24104 11.1955 6.44339 12.1347C5.95389 12.3904 5.81698 13.0124 6.11257 13.4789L11.4648 21.9259C11.7604 22.3925 11.6218 23.0103 11.1553 23.3059L2.70829 28.6582Z",
    fill: "#CFE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.89129 29.1734C-4.64372 29.3359 -5.33539 28.6442 -5.17287 27.8918C-4.05049 22.6951 -3.35317 15.6366 0.283457 11.9998C3.92008 8.36307 10.9784 7.6656 16.175 6.54309C16.9274 6.38056 17.6191 7.07223 17.4565 7.82467C16.3342 13.0214 15.6368 20.0798 12.0002 23.7166C8.36359 27.3534 1.30528 28.0508 -3.89129 29.1734Z",
    fill: "#FFD6F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#00639C",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_883_7054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg3Clicked);
export default __webpack_public_path__ + "static/media/profileImg3Clicked.1d8b8dc545480c1f7479b0d92a832d79.svg";
export { ForwardRef as ReactComponent };